import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _cmCLR from './_cmCLR';
import * as _cmDSN from './_cmDSN';
import * as _cmSCL from './_cmSCL';

let $cashz = {} as _ht.dz;

export const a = (
  cls: _ht.s,
) => {

  if ($cashz[cls]) return $cashz[cls];

  const _ls = cls.split(' ').map( (_s: _ht.s) => {
    const [_clsType, _clsVle] = _s.split('/');
    switch (_clsType) {
      case 'bc': // border color
        return {
          borderColor: _cmCLR.c(_clsVle),
        };
      case 'bd': // border dashed
        return {
          borderStyle: 'dashed',
        };
      case 'br': // border radius
        return {
          borderRadius: _cmSCL.s(Number(_clsVle)),
        };
      case 'brb': // border radius bottom
        return {
          borderBottomLeftRadius: _cmSCL.s(Number(_clsVle)),
          borderBottomRightRadius: _cmSCL.s(Number(_clsVle)),
        };
      case 'brl': // border radius left
        return {
          borderTopLeftRadius: _cmSCL.s(Number(_clsVle)),
          borderBottomLeftRadius: _cmSCL.s(Number(_clsVle)),
        };
      case 'brr': // border radius right
        return {
          borderTopRightRadius: _cmSCL.s(Number(_clsVle)),
          borderBottomRightRadius: _cmSCL.s(Number(_clsVle)),
        };
      case 'brt': // border radius top
        return {
          borderTopLeftRadius: _cmSCL.s(Number(_clsVle)),
          borderTopRightRadius: _cmSCL.s(Number(_clsVle)),
        };
      case 'bs': // border style
        return {
          borderStyle: 
            _clsVle == 'sd' ? 
              'solid'
            : _clsVle == 'ds' ? 
              'dotted'
            :
              'solid',
        };
      case 'bw': // border width
        return {
          borderTopWidth: Number(_clsVle),
          borderBottomWidth: Number(_clsVle),
          borderLeftWidth: Number(_clsVle),
          borderRightWidth: Number(_clsVle),
        };
      case 'bwv': // border width vertical
        return {
          borderTopWidth: Number(_clsVle),
          borderBottomWidth: Number(_clsVle),
        };
      case 'bwh': // border width horizontal
        return {
          borderLeftWidth: Number(_clsVle),
          borderRightWidth: Number(_clsVle),
        };
      case 'bwb': // border width bottom
        return {
          borderBottomWidth: Number(_clsVle),
          borderTopWidth: 0,
        };
      case 'bwt': // border width top
        return {
          borderBottomWidth: 0,
          borderTopWidth: Number(_clsVle),
        };
      case 'bwl': // border width left
        return {
          borderLeftWidth: Number(_clsVle),
          borderRightWidth: 0,
        };
      case 'bwr': // border width right
        return {
          borderLeftWidth: 0,
          borderRightWidth: Number(_clsVle),
        };
      case 'db': // dimension bottom
        return {
          bottom:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
        };
      case 'dh': // dimension height
        if ( _clsVle != 'ecp') { // escape
          const _dz = {
            height:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'page' ? 
                _cmDSN.h('page')
              : _clsVle == 'pageHdr' ? 
                _cmDSN.h('pageHdr')
              : _clsVle == 'main' ? 
                _cmDSN.h('main')
              : _clsVle == 'mainHdr' ? 
                _cmDSN.h('mainHdr')
              : _clsVle == 'mainFtn' ? 
                _cmDSN.h('mainFtn')
              : _clsVle == 'mainBdy' ? 
                _cmDSN.h('mainBdy')
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
          };
//_hm.l(`cmABT 136: ${_clsVle}, ${_hm.s(_dz)}`);
          return _dz;
        }
        else {
          return {};
        }

      case 'dhn': // dimension min height
        if ( _clsVle != 'ecp') { // escape
          return {
            minHeight:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dhx': // dimension max height
        if ( _clsVle != 'ecp') { // escape
          return {
            maxHeight:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dhp': // dimension height
        return {
          height: Number(_clsVle),
        };

      case 'dl': // dimension left
        return {
          left:
            _clsVle == 'f' ? 
              '100%' 
            : _clsVle == 'h' ? 
              '50%' 
            : _clsVle == 'q' ? 
              '25%' 
            : _clsVle == 'n' ? 
              null
            : _cmSCL.s(Number(_clsVle)),
        };

      case 'dlp': // dimension left px
        return {
          left: _clsVle,
        };

      case 'dr': // dimension right
        return {
          right:
            _clsVle == 'f' ? 
              '100%' 
            : _clsVle == 'h' ? 
              '50%' 
            : _clsVle == 'q' ? 
              '25%' 
            : _clsVle == 'n' ? 
              null
            : _cmSCL.s(Number(_clsVle)),
        };

      case 'dp': // dimension position
        return {
          position: 
            _clsVle == 'a' ? 
              'absolute'
            : _clsVle,
        };

      case 'dt': // dimension top
        return {
          top:
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
        };

      case 'dtp': // dimension top in px
        return {
          top: _clsVle,
        };

      case 'dw': // dimension width
        if ( _clsVle != 'ecp') { // escape
          return {
            width: 
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'w1' ?
                170
              : _clsVle == 'w2' ?
                340
              : _clsVle == 'w3' ?
                510
              : _clsVle == 'w4' ?
                680
              : _clsVle == 'w5' ?
                850
              : _clsVle == 'w6' ?
                1020
              : _clsVle == 'icn' ? // identification
                _cmSCL.s(15)
              : _clsVle == 'btn' ? // button
                _cmSCL.s(10)
              : _clsVle == 'date' ? // date
                _cmSCL.s(13)
              : _clsVle == 'page' ? 
                _cmDSN.w('page')
              : _clsVle == 'main' ? 
                _cmDSN.w('main')
              : _clsVle == 'dwr' ? 
                _cmDSN.w('dwr')
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dwn': // dimension min width
        if ( _clsVle != 'ecp') { // escape
          return {
            minWidth: 
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'w1' ?
                170
              : _clsVle == 'w2' ?
                340
              : _clsVle == 'w3' ?
                510
              : _clsVle == 'w4' ?
                680
              : _clsVle == 'w5' ?
                850
              : _clsVle == 'w6' ?
                1020
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dwp': // dimension width in pixel
        return {
          width: Number(_clsVle),
        };

      case 'dwx': // dimension max width
        if ( _clsVle != 'ecp') { // escape
          return {
            maxWidth: 
              _clsVle == 'f' ? 
                '100%' 
              : _clsVle == 'h' ? 
                '50%' 
              : _clsVle == 'q' ? 
                '25%' 
              : _clsVle == 'w1' ?
                170
              : _clsVle == 'w2' ?
                340
              : _clsVle == 'w3' ?
                510
              : _clsVle == 'w4' ?
                680
              : _clsVle == 'w5' ?
                850
              : _clsVle == 'w6' ?
                1020
              : _clsVle == 'n' ? 
                null
              : _cmSCL.s(Number(_clsVle)),
          };
        }
        else {
          return {};
        }

      case 'dz': // dimension zIndex
        return {
          zIndex: 
            _clsVle == 'mainBdy' ? 
              10
            :_clsVle == 'mainBdy+1' ? 
              11
            : _clsVle == 'mdl' ? 
              20
            : _clsVle == 'mdl+1' ? 
              21
            : _clsVle == 'mdl+2' ? 
              22
            : _clsVle,
        };

      case 'f': // flex
        return {
          flex: 
            _clsVle == 'n' ? 
              null
            : _clsVle,
        };

      case 'fd': // flex direction
        switch ( _clsVle ) {
          case 'cac':
            return {
              flexDirection: 'column', 
              justifyContent: 'space-evenly', 
              alignItems: 'center', 
            }
          case 'ccc':
            return {
              flexDirection: 'column', 
              justifyContent: 'center', 
              alignItems: 'center', 
            }
          case 'ccs':
            return {
              flexDirection: 'column', 
              justifyContent: 'center', 
              alignItems: 'flex-start', 
            }
          case 'csc':
            return {
              flexDirection: 'column', 
              justifyContent: 'flex-start', 
              alignItems: 'center', 
            }
          case 'css':
            return {
              flexDirection: 'column', 
              justifyContent: 'flex-start', 
              alignItems: 'flex-start', 
            }
          case 'rac':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-evenly', 
              alignItems: 'center', 
            }
          case 'ras':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-evenly', 
              alignItems: 'flex-start', 
            }
          case 'rbc':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
            }
          case 'rbs':
            return {
              flexDirection: 'row', 
              justifyContent: 'space-between', 
              alignItems: 'flex-start', 
            }
          case 'rcc':
            return {
              flexDirection: 'row', 
              justifyContent: 'center', 
              alignItems: 'center', 
            }
          case 'rec':
            return {
              flexDirection: 'row', 
              justifyContent: 'flex-end', 
              alignItems: 'center', 
            }
          case 'rsc':
            return {
              flexDirection: 'row', 
              justifyContent: 'flex-start', 
              alignItems: 'center', 
            }
          case 'rss':
            return {
              flexDirection: 'row', 
              justifyContent: 'flex-start', 
              alignItems: 'flex-start', 
            }
          default:
            return {
              flexDirection:  
                _clsVle == 'c' ?
                  'column'
                : _clsVle == 'n' ?
                  'column-reverse'
                : _clsVle == 'r' ?
                  'row'
                : _clsVle == 'w' ?
                  'row-reverse'
                : _clsVle,
            }
        }

      case 'fj': // flex justify content
        return {
          justifyContent: 
            _clsVle == 'a' ? 
              'space-evenly'
            : _clsVle == 'b' ? 
              'space-between'
            : _clsVle == 'c' ? 
              'center'
            : _clsVle == 'e' ? 
              'flex-end'
            : _clsVle == 's' ? 
              'flex-start'
            : _clsVle,
        };

      case 'fa': // flex alignItems
        return {
          alignItems:  
            _clsVle == 'a' ? 
              'space-evenly'
            : _clsVle == 'b' ? 
              'space-between'
            : _clsVle == 'c' ? 
              'center'
            : _clsVle == 'e' ? 
              'flex-end'
            : _clsVle == 's' ? 
              'flex-start'
            : _clsVle,
        };

      case 'fw': // flex wrap
        return {
          flexWrap: 
            _clsVle == 'w' ?
              'wrap'
            : _clsVle == 'n' ?
              undefined
            : 'wrap',
        };

      case 'ioc': // input outline color
        return {
          outlineColor:  _cmCLR.c(_clsVle),
        };

      case 'iow': // input outline width
        return {
          outlineWidth:  Number(_clsVle),
        };

      case 'ipt': // input placeholder text
        return {
          placeholder:  _clsVle,
        };

      case 'ipc': // input placeholder text color
        return {
          placeholderTextColor:  _cmCLR.c(_clsVle),
        };

      case 'icc': // icon color
        return {
          color:  _cmCLR.c(_clsVle),
        };

      case 'icn': // icon name
        return {
          name:  _clsVle,
        };

      case 'ics': // icon size
        return {
          size:  _cmSCL.s(Number(_clsVle)),
        };

      case 'm': // margin all
        return {
          marginTop: _cmSCL.s(Number(_clsVle)),
          marginBottom: _cmSCL.s(Number(_clsVle)),
          marginLeft: _cmSCL.s(Number(_clsVle)),
          marginRight: _cmSCL.s(Number(_clsVle)),
        };
      case 'mv': // margin vertical
        return (
          _clsVle == 'a' ?
          {
            marginTop: 'auto',
            marginBottom: 'auto',
          }
          :
          {
            marginTop: _cmSCL.s(Number(_clsVle)),
            marginBottom: _cmSCL.s(Number(_clsVle)),
          }
        );
      case 'mh': // margin horizontal
        return (
          _clsVle == 'a' ?
          {
            marginLeft: 'auto',
            marginRight: 'auto',
          }
          :
          {
            marginLeft: _cmSCL.s(Number(_clsVle)),
            marginRight: _cmSCL.s(Number(_clsVle)),
          }
        );
      case 'mt': // margin top
        return {
          marginTop: _cmSCL.s(Number(_clsVle)),
        };
      case 'mb': // margin bottom
        return {
          marginBottom: _cmSCL.s(Number(_clsVle)),
        };
      case 'ml': // margin left
        return {
          marginLeft: _cmSCL.s(Number(_clsVle)),
        };
      case 'mr': // margin right
        return {
          marginRight: _cmSCL.s(Number(_clsVle)),
        };

      case 'p': // padding all
        return {
          paddingTop: _cmSCL.s(Number(_clsVle)),
          paddingBottom: _cmSCL.s(Number(_clsVle)),
          paddingLeft: _cmSCL.s(Number(_clsVle)),
          paddingRight: _cmSCL.s(Number(_clsVle)),
        };
      case 'pv': // padding vertical
        return (
        {
          paddingTop: _cmSCL.s(Number(_clsVle)),
          paddingBottom: _cmSCL.s(Number(_clsVle)),
        }
        );
      case 'ph': // padding horizontal
        return (
        {
          paddingLeft: _cmSCL.s(Number(_clsVle)),
          paddingRight: _cmSCL.s(Number(_clsVle)),
        }
        )
      case 'pt': // padding top
        return {
          paddingTop: _cmSCL.s(Number(_clsVle)),
        };
      case 'pb': // padding bottom
        return {
          paddingBottom: _cmSCL.s(Number(_clsVle)),
        };
      case 'pl': // padding left
        return {
          paddingLeft: _cmSCL.s(Number(_clsVle)),
        };
      case 'pr': // padding right
        return {
          paddingRight: _cmSCL.s(Number(_clsVle)),
        };
      case 'prx': // padding right
        return {
          paddingRight: Number(_clsVle),
        };

      case 'sc': // background color
        return {
          backgroundColor: _cmCLR.c(_clsVle),
        };

      case 'ta': // text align
        return {
          textAlign: 
            _clsVle == 'c' ? 
              'center'
            : _clsVle == 'l' ? 
              'left'
            : _clsVle == 'r' ? 
              'right'
            : _clsVle,
        };

      case 'tb': // text font style bold
        return {
          fontWeight: 
            _clsVle == 'n' ? 
              'normal'
            : 'bold',
        };

      case 'tc': // text font color
        return {
          color: _cmCLR.c(_clsVle),
        };

      case 'tf': // text font family
        return {
          fontFamily: _clsVle,
        };

      case 'ti': // text font style italic
        return {
          fontStyle: 'italic',
        };

      case 'tm': // text multiline
        return {
          multiline: 
            _clsVle == 'n' ? 
            false
          : true,
        };

      case 'tn': // text number of lines
        return {
          numberOfLines: 
          _clsVle == 'n' ?
            undefined
          : Number(_clsVle),
          ellipsizeMode: 'middle',
        };

      case 'ts': // text font size
/*
        return {
          fontSize:
            _clsVle == 'm' ?
              _cmSCL.s(2.0)
            : _clsVle == 's' ?
              _cmSCL.s(1.7)
            : _clsVle == 'xs' ?
              _cmSCL.s(1.4)
            : _clsVle == 'xxs' ?
              _cmSCL.s(1.1)
            : _clsVle == 'l' ?
              _cmSCL.s(2.3)
            : _clsVle == 'xl' ?
              _cmSCL.s(2.6)
            : _clsVle == 'xxl' ?
              _cmSCL.s(2.9)
            : _cmSCL.s(Number(_clsVle)),
        };
*/
        const _dz = {
          fontSize:
            _clsVle == 'm' ?
              _cmSCL.s(2.0)
            : _clsVle == 's' ?
              _cmSCL.s(1.7)
            : _clsVle == 'xs' ?
              _cmSCL.s(1.4)
            : _clsVle == 'xxs' ?
              _cmSCL.s(1.1)
            : _clsVle == 'l' ?
              _cmSCL.s(2.3)
            : _clsVle == 'xl' ?
              _cmSCL.s(2.6)
            : _clsVle == 'xxl' ?
              _cmSCL.s(2.9)
            : _cmSCL.s(Number(_clsVle)),
        };
        //_hm.l(`cmABT 738: ${_clsVle}, ${_hm.s(_dz)}`);
        return _dz;

      case 'tu': // text font style underline
        return {
          textDecoration: 'underline',
        };

      default:
        console.log('csStl 167: incorrect class Name: ' + cls)
        return {
        }
    }
  });

  const _stlz = {};
  _ls.map( (_dz: _ht.dz) => {
    _hm.udtDz(_stlz, _dz);
  });

  $cashz[cls] = _stlz;

  return _stlz;
};

export const clr = () => {
  $cashz = {};
};